import { CommonInfoService } from './../../../cart-process/common-info.service';
import { CustomerDetailsByProcess, CustomerDetailsModel } from './../../../models/customer-details.model';

import { AfterContentInit, Component, ContentChild, ElementRef, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormFieldsMasks } from '../../field-mask/form-fields-masks';
import { UserDataFormService } from '../../user-data/user-data-form.service';
import { BrandTypeEnum } from '../../../models/cartDetails/brand-type.enum';
import { NotificationProviderService, NotificationProviderTypeEnum } from '../../../external-interfaces/notification-provider.service';
import { ProvinceSelectModalService } from 'src/ng2-app/scripts/services/province-select-modal.service';

interface FormFieldData {
  value?: string;
  label?: string;
  helper?: string;
  divClass?: string;
  labelClass?: string;
  labelTestId?: string;
  inputTestId?: string;
}
@Component({
  selector: 'form-field',
  templateUrl: './form-field.component.html'
})
export class FormFieldComponent implements AfterContentInit {
  @Input() data: any;
  @Input() formGroup: FormGroup;

  public elementData: FormFieldData;
  public customerDetails: CustomerDetailsModel | CustomerDetailsByProcess;
  public commonInfo: CommonInfoService;
  public formControlGroup: string;
  public selectedDate: string;
  public showCalendar = false;

  @ContentChild('inputRef', { static: false }) input: ElementRef;

  constructor(
    public validationMasks: FormFieldsMasks,
    public userDataFormService: UserDataFormService,
    public userDataFormOtherAddress: UserDataFormService,
    protected elementRef: ElementRef,
    private notificationProviderService: NotificationProviderService,
    public provinceSelectModalService: ProvinceSelectModalService
  ) {

    this.notificationProviderService.subscribe(NotificationProviderTypeEnum.COMMON_INFO, (commonInfo: CommonInfoService) => {
      if (commonInfo) {
        this.commonInfo = commonInfo;
      }
    });

    this.notificationProviderService.subscribe(NotificationProviderTypeEnum.CONFIG, (config) => {
      if (config) {
        this.commonInfo.isVirginBrand = config.brand === BrandTypeEnum.VIRGIN;
      }
    });

    if (this.commonInfo.isMigrationOffer) {
      this.customerDetails = new CustomerDetailsByProcess();
    } else {
      this.customerDetails = new CustomerDetailsModel();
    }
  }

  ngAfterContentInit(): void {
    this.createElement();
  }

  private createElement(): void {
    const labelEl = this.data['label'] || {};
    const inputEl = this.data['input'] || {};

    if (this.data.isEditable && this.data.label && this.data.input) {
      let helper = '';
      let inputClass = inputEl['_input-class'] || '';
      const divClass = inputEl['_div-class'] || '';
      const labelClass = labelEl['_label-class'] || '';
      const placeholderClass = inputEl.formControlName && this.formGroup?.controls[inputEl.formControlName]?.value !== '' ? 'placeholder-not-shown' : '';
      this.formControlGroup = inputEl.formControlGroup ? inputEl.formControlGroup : '';

      if (placeholderClass) {
        inputClass += ` ${placeholderClass}`;
      }

      if (typeof inputEl['_input-helper'] === 'function') {
        helper = inputEl['_input-helper'](this.commonInfo, this.data.input.formControlName);
      } else if (typeof inputEl['_input-helper'] === 'string') {
        helper = inputEl['_input-helper'];
      }

      this.elementData = {
        divClass,
        labelClass,
        label: labelEl._label,
        helper
      };


      this.input.nativeElement.setAttribute('class', inputClass);

    } else if (!this.data.isEditable && this.data.label && this.data.input) {
      const labelTestId = labelEl['data-automation-id'];
      const inputTestId = labelEl['data-automation-id'];
      const divClass = this.data.uid === 'pesel' ? 'no-border' : '';
      let value = '';

      if (inputEl['staticValue']) {
        value = this.customerDetails[inputEl['staticValue']];
      }

      this.elementData = {
        labelTestId,
        inputTestId,
        divClass,
        value,
        label: labelEl._label,
      };
    }
  }

  public toggleCalendar(): void {
    this.showCalendar = !this.showCalendar;

    if (this.showCalendar) {
      this.input.nativeElement.focus();
    } else {
      this.input.nativeElement.blur();
    }
  }

  protected onDateSelected(date: string): void {
    this.selectedDate = date;
    this.formGroup.get(this.data['input'].formControlName).setValue(date);
    this.showCalendar = false;
  }

  public onCloseCalendar(): void {
    this.showCalendar = false;
  }
}
